import { IPaginatedResult } from '@/dto/paginated-result.dto';
import { IUserDetailForAdmin } from '../../dto/user/user-details-for-admin.dto';
import { IUser } from '../../types/user.type';
import ControllerRequest from './_controller.base';
import { UserRoleEnum, UserStatusEnum } from '@/enums';

export class UserController extends ControllerRequest {
    constructor() {
        super('user');
    }

    getMe(): Promise<IUser> {
        return this.execGET('/me');
    }

    getUserList({ page,  sortBy, search, status }: {
        page?: number;
        sortBy?: [string, 'ASC' | 'DESC'][];
        search?: string;
        status?: UserStatusEnum;
    }): Promise<IPaginatedResult<IUserDetailForAdmin>> {
        if (page !== undefined) {
            this.addParam('page', String(page));
        }
        if (sortBy && Array.isArray(sortBy) && sortBy.length > 0) {
            this.addParam('sortBy', JSON.stringify(sortBy));
        }
        if (search !== undefined && search !== '') {
            this.addParam('search', search);
        }
        if (status !== undefined) {
            this.addParam('filter.security.status', `$eq:${status}`);
        }
        return this.execGET('/admin/list');
    }

    updateUserRequest(userId: string, action: 'approved'|'denied') {
        const url = `/${userId}/request/${action}`;
        const data = {
            userId
        };
        return this.execPUT(data, url);
    }

    updateUserRole(userId: string, role: UserRoleEnum, action: 'remove'|'add') {
        const url = `/${userId}/roles/${action}`;
        const data = {
          roleName: role
        };
        return this.execPOST(data, url);
    }
}
